"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFrontendTimezone = exports.normalizeToMillisecond = exports.DATE_FORMATS = exports.getTimestamp = exports.getDefaultTimezone = exports.dayjs = void 0;
/**
 * @ark/dayjs/frontend - 前端专用的 dayjs 实例
 *
 * 与后端默认入口（@ark/dayjs）能力一致，但时区来源为宿主注入的
 * window._params.siteId，而非 @ark/env（后者依赖 @futu/appinfo，属后端专用）。
 *
 * 依赖约束：只依赖 dayjs 与 @ark/utils 纯枚举，
 * 不会把 @ark/env / @futu/appinfo 打进前端 bundle。
 *
 * @example
 * ```typescript
 * import { dayjs, DATE_FORMATS } from '@ark/dayjs/frontend';
 *
 * // 按展业时区计算今天 00:00:00
 * const todayStart = dayjs().startOf('day').valueOf();
 *
 * // 判断时间戳是否为展业时区的今天
 * const isToday = dayjs(ts).isSame(dayjs(), 'day');
 * ```
 */
const create_dayjs_1 = require("./create-dayjs");
const frontend_timezone_1 = require("./frontend-timezone");
const { dayjs, getDefaultTimezone, getTimestamp } = (0, create_dayjs_1.createArkDayjs)((0, frontend_timezone_1.resolveFrontendTimezone)());
exports.dayjs = dayjs;
exports.getDefaultTimezone = getDefaultTimezone;
exports.getTimestamp = getTimestamp;
var create_dayjs_2 = require("./create-dayjs");
Object.defineProperty(exports, "DATE_FORMATS", { enumerable: true, get: function () { return create_dayjs_2.DATE_FORMATS; } });
Object.defineProperty(exports, "normalizeToMillisecond", { enumerable: true, get: function () { return create_dayjs_2.normalizeToMillisecond; } });
var frontend_timezone_2 = require("./frontend-timezone");
Object.defineProperty(exports, "resolveFrontendTimezone", { enumerable: true, get: function () { return frontend_timezone_2.resolveFrontendTimezone; } });
